export const testimonials = [
  {
    id: 1,
    name: "Lucas Oliveira",
    username: "@lucasoliv",
    avatar: "LO",
    text: "A CSSBuySpreadsheet mudou completamente minha experiência de compra. Antes eu perdia horas procurando links bons, agora encontro tudo organizado e verificado. Já economizei mais de R$500 em compras.",
  },
  {
    id: 2,
    name: "Marina Santos",
    username: "@marinas",
    avatar: "MS",
    text: "Como iniciante, tinha muito medo de comprar da China. Os guias da CSSBuySpreadsheet me deram toda a segurança que eu precisava. Comprei 3 vezes e todas foram perfeitas.",
  },
  {
    id: 3,
    name: "Pedro Costa",
    username: "@pedrocosta_pt",
    avatar: "PC",
    text: "De Portugal, o CSSBuySpreadsheet foi essencial. As dicas de frete e alfândega são muito precisas. Recomendo para qualquer pessoa que queira comprar com segurança.",
  },
  {
    id: 4,
    name: "Ana Ferreira",
    username: "@anaferr",
    avatar: "AF",
    text: "A planilha é atualizada diariamente, isso faz toda diferença. Links que funcionam, vendedores confiáveis e preços reais. Não compro sem consultar a CSSBuySpreadsheet primeiro.",
  },
  {
    id: 5,
    name: "Rafael Almeida",
    username: "@rafa_almeida",
    avatar: "RA",
    text: "Já usei vários agentes e planilhas, mas a CSSBuySpreadsheet é a mais completa em português. Os comparativos entre agentes me ajudaram a economizar muito em frete.",
  },
  {
    id: 6,
    name: "Carolina Mendes",
    username: "@carolmendes",
    avatar: "CM",
    text: "Comecei a comprar tênis e roupas pelo CSSBuy graças a esta planilha. Os guias de QC são incríveis, me sinto segura em cada compra. Minha coleção cresceu muito!",
  },
];